import { render, staticRenderFns } from "./CustomerEmployeesDelete.vue?vue&type=template&id=541eb020&scoped=true"
import script from "./CustomerEmployeesDelete.vue?vue&type=script&lang=js"
export * from "./CustomerEmployeesDelete.vue?vue&type=script&lang=js"
import style0 from "./CustomerEmployeesDelete.vue?vue&type=style&index=0&id=541eb020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541eb020",
  null
  
)

export default component.exports